import { useEffect, useState } from "react";
import LanguageOption from "./languageOption/LanguageOption"
import { useLanguageContext } from "../../../context/languageContext/LanguageContext";

export default function LanguageOptionBox() {
  const [LanaguageOptionBox, SetLanguageOptionBox] = useState({display: "none"})
  const { IsLanguageOptionActive} = useLanguageContext(); 
  
  useEffect(() => {
    if(IsLanguageOptionActive){
      SetLanguageOptionBox({})
    }
  },[IsLanguageOptionActive])

  return (
    <div id="LanguageOptionBox" style={LanaguageOptionBox}>
      <LanguageOption index={0} language="enUS" label="English" />
      <LanguageOption index={1} language="ptBR" label="Português" />

    </div>
  );
}